'use client';

import { createContext, useContext, useEffect, useRef } from 'react';
import {
  acquisitionContext,
  documentFunnelOpening,
  safelyTrack,
} from '@/app/utils/funnel-analytics';
import { usePathname } from 'next/navigation';
import Tracker from '@/app/utils/tracker';

export const TrackingContext = createContext<Tracker | null>(null);

export const useTracking = () => {
  const tracker = useContext(TrackingContext);
  if (!tracker) throw new Error('useTracking must be used within TrackingProvider');
  return tracker;
};

export default function TrackingProvider({ children }: { children: React.ReactNode }) {
  const trackerRef = useRef<Tracker | null>(null);
  if (!trackerRef.current) trackerRef.current = new Tracker();
  const tracker = trackerRef.current;
  const pathname = usePathname();
  useEffect(() => {
    safelyTrack(() => {
      documentFunnelOpening(pathname);
      acquisitionContext();
    });
  }, [pathname]);
  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if ((event.key === 'pz-session' && !event.newValue) || event.key === 'pz-logout_generation') {
        tracker.resetUser();
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [tracker]);
  return <TrackingContext.Provider value={tracker}>{children}</TrackingContext.Provider>;
}
